(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('UserPausedController', userpause);

  userpause.$inject = ['$rootScope', 'ControlPauseService', 'ReasonService', 'LocalStorageService'];

  function userpause ($rootScope, ControlPauseService, ReasonService, LocalStorageService) {
    var vmUserPauseCtrl = this;

    if (!LocalStorageService.checkInPause()) {
      LocalStorageService.sendToChatPage();
      return;
    }

    vmUserPauseCtrl.getReasonPause = [];
    vmUserPauseCtrl.changeReason = changeReason;
    vmUserPauseCtrl.setPause = setPause;
    vmUserPauseCtrl.metadata = $rootScope.company_metadata;
    getReasonPause();

    function isValidPause () {
      if (vmUserPauseCtrl.metadata.hasOwnProperty('control_pause') &&
              ((vmUserPauseCtrl.metadata.control_pause.hasOwnProperty('use_password') &&
                vmUserPauseCtrl.metadata.control_pause.use_password) ||
              (vmUserPauseCtrl.metadata.control_pause.hasOwnProperty('use_reason') &&
                vmUserPauseCtrl.metadata.control_pause.use_reason)
              )
      ) {
        if (vmUserPauseCtrl.metadata.control_pause.use_password) {
          if (vmUserPauseCtrl.pwd === '' || vmUserPauseCtrl.pwd === null || vmUserPauseCtrl.pwd === undefined) {
            vmUserPauseCtrl.statusPause = true;
            vmUserPauseCtrl.errorHandler = { 'status': 'warning', 'message': 'Para remover a pausa é necessario informar sua senha de login!' };
            return false;
          }
        }
        if (!vmUserPauseCtrl.motivoPausa && vmUserPauseCtrl.metadata.control_pause.use_reason) {
          vmUserPauseCtrl.statusPause = true;
          vmUserPauseCtrl.errorHandler = { 'status': 'warning', 'message': 'Para remover a pausa é necessario selecionar um motivo!' };
          return false;
        }
      }
      return true;
    }

    function setPause () {
      if (isValidPause()) {
        ControlPauseService
          .update({ id: $rootScope.user_data.session_user.id, is_paused: false, pwd: vmUserPauseCtrl.pwd })
          .$promise
          .then(function (data) {
            vmUserPauseCtrl.pwd = null;
            vmUserPauseCtrl.motivoPausa = null;
            $rootScope.user_data.operator_status = true;
            vmUserPauseCtrl.statusPause = false;
            $rootScope.user_data.session_user.is_paused = false;
            LocalStorageService.clearUserPauseState();
            LocalStorageService.sendToChatPage();
          })
          .catch(function (error) {
            vmUserPauseCtrl.statusPause = true;
            $rootScope.user_data.operator_status = false;
            vmUserPauseCtrl.errorHandler = { 'status': 'alert', 'message': error.data.message };
          });
      }
    }

    function changeReason () {
      if (vmUserPauseCtrl.motivoPausa) {
        ControlPauseService
          .changeReason({ id: $rootScope.user_data.session_user.id, reason: vmUserPauseCtrl.motivoPausa })
          .$promise
          .then(function (data) {
          })
          .catch(function (error) {
          });
      }
      vmUserPauseCtrl.errorHandler = null;
    }

    function getReasonPause () {
      ReasonService
        .getReasonPause()
        .$promise
        .then(function (data) {
          vmUserPauseCtrl.getReasonPause = data;
        })
        .catch(function (error) {

        });
    }
  }
})();
